import { AppModule } from 'app/module';
import './styles.scss';
import Template from './template.hbs';

export class InactiveJobCupcake extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            cupcakeText: '.m-inactiveJobCupcake__text',
        };
    }

    getPropsFromDom() {
        return {
            cupcakeText: this.dom.cupcakeText ? this.dom.cupcakeText.innerText : '',
        };
    }
}
